import { render, staticRenderFns } from "./BnSubUgyfelHeaderTile.vue?vue&type=template&id=4353a312&scoped=true&"
import script from "./BnSubUgyfelHeaderTile.vue?vue&type=script&lang=js&"
export * from "./BnSubUgyfelHeaderTile.vue?vue&type=script&lang=js&"
import style0 from "./BnSubUgyfelHeaderTile.vue?vue&type=style&index=0&id=4353a312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353a312",
  null
  
)

export default component.exports